import { ChevronDownIcon, ChevronRightIcon } from "@minervaproject/fds";
import React, { CSSProperties, useState } from "react";

const FDS_RED = "#DF2F26";

function ExpandableTableRow({
  children,
  expandedContent,
  colSpan,
  iconColor = null,
  error = false,
}: {
  children: React.ReactNode;
  expandedContent: React.ReactNode;
  colSpan: number;
  iconColor?: string | null;
  error?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const rowStyle: CSSProperties = {
    cursor: "pointer",
  };
  if (error) {
    rowStyle.backgroundColor = "var(--red-tint-90)";
  }
  const chevronColor = iconColor || (error ? FDS_RED : null);

  return (
    <>
      <tr onClick={() => setIsOpen(!isOpen)} style={rowStyle}>
        <td className="col-1">
          {isOpen ? (
            <ChevronDownIcon color={chevronColor} />
          ) : (
            <ChevronRightIcon color={chevronColor} />
          )}
        </td>
        {children}
      </tr>
      {isOpen ? (
        <tr style={error ? { backgroundColor: "var(--red-tint-90)" } : undefined}>
          <td colSpan={colSpan + 1}>{expandedContent}</td>
        </tr>
      ) : null}
    </>
  );
}

export { ExpandableTableRow };
